exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b149b182] .el-carousel {\n  height: 100%;\n}\n[data-v-b149b182] .el-carousel .el-carousel__container {\n  height: 100%;\n}", ""]);

// exports
